/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineAxisArrowDown: {
  name: 'line-axis-arrow-down';
  data: string;
} = {
  name: 'line-axis-arrow-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 .5a.5.5 0 0 1 .5.5v8.793l2.146-2.147a.5.5 0 0 1 .708 0L8 11.293l4.646-4.647a.5.5 0 0 1 .708.708l-5 5a.5.5 0 0 1-.708 0L4 8.707l-2.5 2.5V14.5H15a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5V1A.5.5 0 0 1 1 .5Zm7 0a.5.5 0 0 1 .5.5v4.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 5.793V1A.5.5 0 0 1 8 .5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
